<template>
<div>
	<button class="accordion" @click="isActive = !isActive" :class="{ active: isActive }">{{title}}</button>
	<transition name='acc'>
		<div class="panel" v-show='isActive'>
		
				<slot></slot>
			
		</div>	
	</transition>
	
</div>

</template>

<script>
export default {
  name:'accordion',
  props: ['title'],
  data:function(){
    return {
      isActive:false
    }
    
  },


}
</script>

<style lang="scss" scoped>

.acc-enter {
	max-height: 0;
	opacity: 0;
}

.acc-enter-active, .acc-leave-active  {
	transition: 1s ease;
	
}

.acc-enter-to {
	max-height: 100vh;
	opacity: 1;

}

.acc-leave {
	max-height: 100vh;
	
}
.acc-leave-to {
	max-height: 0px;
	opacity: 0;
	
}
  
.accordion {
	background-color: transparent ;
    font-family: "Roboto", sans-serif;
    letter-spacing: 10pt;
    color: #fff;
    cursor: pointer;
    width: 100%;
    border: none;
    border-bottom: 1px solid #444;
    text-align: left;
    outline: none;
    font-size: 15px;
	transition: 0.4s;
	padding:5px 0;
	margin-bottom:10px;
	i {
		float: right;
	}
  }
  

  .accordion:after {
	font-family: 'Material Icons';  
	content: 'expand_more';
	color: #fff;
	font-weight: bold;
	float: right;
	margin-left: 5px;
	
  }
  
  .active:after {
	content: "expand_less";
  }
  
  .panel {
	
	width:95%;

  }



</style>